import { render, staticRenderFns } from "./EmploymentDetailForm.vue?vue&type=template&id=8a1295c0"
import script from "./EmploymentDetailForm.vue?vue&type=script&lang=js"
export * from "./EmploymentDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports